import React, { useState } from 'react';

// Hooks
import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Utils
import { deleteApi } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// Endpoints
import { DELETE_LIBRARY_MEDIA } from '@/lib/routes/apiEndpoints';

// Components
import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner';
import Modal from '@/components/base/Modal';

export const DeleteMediaModal = ({ isOpen, toggle, deleteSuccess, mediaIds = [] }) => {
    const { t } = useTranslation('media');
    const { activeSocialProfile } = useActiveSocialProfile();
    const [deleteState, setDeleteState] = useState({
        isSubmitting: false,
        error: null
    });

    const deleteMedia = async () => {
        setDeleteState({
            isSubmitting: true,
            error: null
        });
        try {
            await deleteApi(
                injectEndpointUrlParams(DELETE_LIBRARY_MEDIA, {
                    SPID: activeSocialProfile.id
                }),
                { data: { library_medias_ids: mediaIds } }
            );
            deleteSuccess(mediaIds);
            toggle();
            setDeleteState((prevState) => ({ ...prevState, isSubmitting: false }));
        } catch (e) {
            setDeleteState({
                isSubmitting: false,
                error: t('errors:error_occurred_delete_data')
            });
        }
    };

    return (
        <Modal open={isOpen} onDismiss={toggle} className="!z-100">
            <Modal.Body>
                {deleteState.error ? (
                    <InfoBanner
                        className="mb-4"
                        title={t('errors:error')}
                        message={deleteState.error}
                        onClose={() => {
                            setDeleteState((prevState) => ({
                                ...prevState,
                                error: null
                            }));
                        }}
                    />
                ) : null}
                <Modal.Title>
                    {mediaIds.length === 1
                        ? t('delete_media_file_one')
                        : t('delete_media_file_other', { count: mediaIds.length })}
                </Modal.Title>
                <Modal.Content>
                    <p className="pt-m text-center font-GMedium text-base text-icoGray-500">
                        {mediaIds.length === 1
                            ? t('delete_media_file_confirm_one')
                            : t('delete_media_file_confirm_other', { count: mediaIds.length })}
                    </p>
                </Modal.Content>
                <Modal.Footer className="my-8 flex justify-between space-x-6">
                    <Button
                        variant="secondary"
                        className="w-full"
                        disabled={deleteState.isSubmitting}
                        onClick={toggle}>
                        {t('commons:no')}
                    </Button>
                    <Button
                        className="w-full"
                        isLoading={deleteState.isSubmitting}
                        disabled={deleteState.isSubmitting}
                        onClick={deleteMedia}>
                        {t('commons:yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteMediaModal;
